module.exports = __webpack_public_path__ + "static/media/discover.7ceda3e3.png";